import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import {routerInstance} from '@aofl/router';
import {SearchParams} from '../search-url-params';

/**
 * @summary SearchDataTable
 * @extends {mapStatePropertiesMixin(AoflElement)}
 */
@customElement('search-data-table')
class SearchDataTable extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of SearchDataTable.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'search-data-table';

  searchTargetUrl = '';
  profileTargetUrl = '';

  @property({type: Array, attribute: false, hasChanged(val, oldVal) {
    if (typeof oldVal === 'undefined') return false;
    return oldVal !== val;
  }})
  results = [];

  @property({type: Array, attribute: false})
  config = [];

  @property({type: Boolean, attribute: false})
  allSelected = false;

  @property({type: String})
  ['search-namespace'] = sdoNs.GROUP_SEARCH;

  @property({type: Boolean})
  ['disable-selection'] = false;

  @property({type: Array, attribute: true})
  styles = [];

  @property({type: String})
  ['on-select-modal'] = '';

  @property({type: String})
  ['aria-label'] = '';

  async changeSortHandler(e) {
    this.storeInstance.commit({
      namespace: this['search-namespace'],
      mutationId: 'updateSortOrder',
      payload: {
        index: e.detail.index,
        field: e.detail.item.key
      }
    }, {
      namespace: this['search-namespace'],
      mutationId: 'removeSortLastValues'
    });
    try {
      const state = storeInstance.getState();
      const queryObj = state[this['search-namespace']].queryObj;
      const searchParams = SearchParams.encode(queryObj);
      await routerInstance.navigate(`${this.searchTargetUrl}?${searchParams}`, {});
    } catch (e) {}
  }

  rowClickHandler(e) {
    if (!this['on-select-modal']) {
      routerInstance.navigate(`${this.profileTargetUrl}${e.detail.data.id}/`, {});
    }
  }

  allToggleHandler(e) {
    this.allSelected = e.detail.checked;
    if (this.allSelected) {
      this.storeInstance.commit({namespace: this['search-namespace'], mutationId: 'selectAll', payload: e.detail});
      this.dispatchEvent(new CustomEvent('select-all-triggered', {
        composed: true,
      }));
    } else {
      this.storeInstance.commit({namespace: this['search-namespace'], mutationId: 'deselectAll'});
    }
  }

  pageToggleHandler(e) {
    this.allSelected = e.detail.checked;
    if (this.allSelected) {
      this.storeInstance.commit({namespace: this['search-namespace'], mutationId: 'selectPage', payload: e.detail});
    } else {
      this.storeInstance.commit({namespace: this['search-namespace'], mutationId: 'deselectAll'});
    }
  }

  persistentSelectionToggleHandler(e) {
    this.storeInstance.commit({namespace: this['search-namespace'], mutationId: 'selectPage', payload: e.detail});
  }

  rowToggleHandler(e) {
    const checked = e.detail.checked;
    const id = e.detail.data.id;
    this.allSelected = false;

    if (checked) {
      this.storeInstance.commit(
        {namespace: this['search-namespace'], mutationId: 'select', payload: {id}}
      );
    } else {
      this.storeInstance.commit(
        {namespace: this['search-namespace'], mutationId: 'deselect', payload: {id}}
      );
    }
  }

  mapStateProperties() {
    const state = this.storeInstance.getState();
    const searchState = state[this['search-namespace']];

    this.results = searchState.results;
    this.config = searchState.tableConfig;
    this.searchTargetUrl = searchState.searchTargetUrl;
    this.profileTargetUrl = searchState.profileTargetUrl;
    this.allSelected = (
      searchState.queryObj.selection_mode === 'all'
      ||
      searchState.selected.length === searchState.queryObj.sort.limit
    );
    this.ariaLabel = this['aria-label'];
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default SearchDataTable;
